var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 180H75a5 5 0 010-10h25v-20H75a5 5 0 01-4.85-3.79l-10-39.89l-.06-.21l-10-39.9A4.89 4.89 0 0150 65V35a15 15 0 0130 0v29.38L88.9 100H145a5 5 0 010 10H91.4l2.5 10H135a15 15 0 0115 15v10a5 5 0 01-5 5h-35v20h25a5 5 0 010 10zm-30-40h35v-5a5 5 0 00-5-5H90a5 5 0 01-4.85-3.79L81.1 110h-9.7l7.5 30zm-36.1-40h9.7l-8.45-33.79A4.89 4.89 0 0170 65V35a5 5 0 00-10 0v29.38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.6dcba4f4d6130f80def555d3946b5104.svg";
export { ForwardRef as ReactComponent };